<div class="tooltip" role="tooltip" [class.show]="visible"
  [style.left.px]="x" [style.top.px]="y" [attr.aria-hidden]="!visible">
  {{ text }}
</div>
